/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Scan Job type. 
*/
export enum ScanJobType {
  ScanJobTypeUnspecified = 'SCAN_JOB_TYPE_UNSPECIFIED',
  AwsEc2Scan = 'AWS_EC2_SCAN',
  AwsRdsScan = 'AWS_RDS_SCAN',
  AwsS3Scan = 'AWS_S3_SCAN',
  AwsDynamoDbScan = 'AWS_DYNAMO_DB_SCAN',
  AwsEksNamespaceScan = 'AWS_EKS_NAMESPACE_SCAN',
  AzureStorageAccountScan = 'AZURE_STORAGE_ACCOUNT_SCAN',
  AzureVmScan = 'AZURE_VM_SCAN',
  AzureSqlDatabaseScan = 'AZURE_SQL_DATABASE_SCAN',
  AzureSqlVirtualMachineScan = 'AZURE_SQL_VIRTUAL_MACHINE_SCAN',
  GcpComputeEngineInstanceScan = 'GCP_COMPUTE_ENGINE_INSTANCE_SCAN',
  GcpCloudStorageScan = 'GCP_CLOUD_STORAGE_SCAN',
  GcpCloudSqlScan = 'GCP_CLOUD_SQL_SCAN',
  AtlasMongodbClusterScan = 'ATLAS_MONGODB_CLUSTER_SCAN'
}
